import dynamic from 'next/dynamic';
import { useState } from 'react';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import ProductNav from '@/components/ProductCommon/ProductNav';
import { useGlobal } from '@/utils/useGlobal';
import SEOlinksA from '@/components/SEOlinksA';
import { getProductMsg, getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useSupportData } from '@/utils/hooks';
import getCanEnterFlag from '@/utils/getCanEnterFlag';
import PageConPc from '@/components/productSmart/glacier';
import ProductSpecs from '@/components/ProductCommon/ProductSpecs';

const PageConH5: any = dynamic(() => import('@/componentsH5/productSmart/glacier'), { ssr: true });
const ProductSupport: any = dynamic(() => import('@/components/ProductCommon/ProductSupport'), { ssr: false });

// 产品详情页参数
const productName = 'glacier-portable-refrigerator';
const generalKey = 'product_fridge_bx100';
const whiteList: string[] = ['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'cn', 'jp', 'kr', 'sa', 'au', 'tw', 'kr', 'za', 'br', 'mx', 'ph'];
export default function Page({ SEO }: any) {
    const { isMobile, gloproductlist, useRouter, useEffect, useLang, getSystemTime } = useGlobal();
    const router = useRouter();
    const { t } = useLang('glacier');
    const { locale } = router;
    const [theme, setTheme] = useState('black');
    const [tabName, setTabName] = useState<string>('Overview');
    const PageCon = isMobile ? PageConH5 : PageConPc;
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    // 从全局的列表中--获取产品详情的基本信息
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey });
    if (!router.isReady) {
        return null;
    }
    const { flag1, flag2, flag3 } = getCanEnterFlag(router?.query?.cid, getSystemTime()); // 提前打开4-26号
    const [resProductCatagory, productDetail, supportData] = useSupportData(getProductMsg, locale, productMsg);
    // 切换tab
    const tabState = (val: any) => {
        setTabName(val);
        const target1 = document.querySelector('.product-tab.show-tab') as HTMLDivElement;
        const target2 = document.querySelector(`.product-tab-${val}`) as HTMLDivElement;
        if (target1) target1?.classList.remove('show-tab');
        if (target2) target2?.classList.add('show-tab');
    };

    useEffect(() => {
        if (!whiteList.includes(locale)) {
            router.push(`/404`);
        }
    }, [locale, router]);

    return (
        <>
            <SEO title={productMsg.title || t('seo_title')} description={productMsg.description || t('seo_desc')} />
            <SEOlinksA list={whiteList} locale={locale} pathname={productMsg.url} />
            <GtmPageLoad />
            <PageLayout className={`${css.productcontent} ${theme} product_common product_common_real product_common_0426`} theme={theme}>
                <ProductNav
                    className="wbg glacier-wbg"
                    title={productMsg?.name}
                    theme={theme}
                    buyLink={productMsg?.buyLink || ''}
                    callback={tabState}
                    productKey={productName}
                    buyLinkText={t('')}
                />
                <div className="product-tab product-tab-Overview show-tab">
                    <PageCon
                        productDetail={productDetail}
                        resProductCatagory={resProductCatagory}
                        supportData={supportData}
                        callBackTheme={setTheme}
                        ecoflowflag={flag1}
                        ecoflowflag2={flag2}
                        ecoflowflag3={flag3}
                    />
                </div>
                <div className="product-tab product-tab-Specs">
                    {tabName === 'Specs' && <ProductSpecs theme={theme} productDetail={productDetail} resProductCatagory={resProductCatagory} />}
                </div>
                <div className="product-tab product-tab-Support">{tabName === 'Support' && <ProductSupport theme={theme} supportData={supportData} />}</div>
            </PageLayout>
        </>
    );
}
